import lineHeight from 'line-height';
import './RollHoverBtn.scss';

export default class RollHoverBtn {
  constructor(element) {
    this.element = element;
    this.className = 'roll-hover-btn';
    this.init();
  }

  createLabel(className = '') {
    const text = $(this.element).text();
    return $(`
      <div class="${this.className}__label ${className ? `roll-hover-btn__label_${className}` : ''}">
        <p>${text}</p>
      </div>
      `);
  }

  createContainer() {
    return $(`<div class="${this.className}__container" />`);
  }

  init() {
    const height = lineHeight(this.element);
    const $label = this.createLabel();
    const $labelActive = this.createLabel('active');
    const $container = this.createContainer();
    $container
      .css({ height, 'line-height': `${height}px` })
      .append($label)
      .append($labelActive);
    $(this.element)
      .text('')
      .addClass(this.className)
      .append($container);
  }
}



// WEBPACK FOOTER //
// ./scripts/elements/RollHoverBtn/RollHoverBtn.js